<header class="search-header">
  <div class="navbar p-2">
    <div class="nav-item">
      <a
        [queryParamsHandling]="'preserve'"
        [routerLink]="['/']"
        class="navbar-logo"
      >
        <img [src]="'assets/logo.svg?v=2' | deployUrl" alt="logo" />
      </a>
    </div>
    <div class="nav-item">
      <button (click)="close()" class="search-header__close-button">
        <span class="search-header__close-button-text">Sluiten</span>
        <fa-icon icon="xmark" size="xl"></fa-icon>
      </button>
    </div>
  </div>
</header>
<div class="search-header__input border-bottom">
  <wl-search-bar [autofocus]="true"></wl-search-bar>
</div>
